import '@/common';
import { createMapWidget } from '@/widgets/MapWidget';

window.addEventListener('load', () => {
    createMapWidget(document.querySelector('#map-widget')!);
});

const configurable = process.env.NODE_ENV === 'development';

Object.defineProperties(window, {
    $contacts: {
        value: Object.freeze({
            setMode(mode: any) {
                document.body.setAttribute('data-mode', mode);
            },
        }),
        configurable,
    },
});
